import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicBreakoutSession } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

export const getBreakoutSessions = async (
  sessionId: string,
): Promise<PublicBreakoutSession[]> => {
  const response = await axiosClient.get(
    `/sessions/${sessionId}/in-call/breakout-rooms`,
  );
  return response.data;
};

export function useGetBreakoutSessions(
  sessionId: string,
  queryOptions?: Partial<UseQueryOptions<PublicBreakoutSession[], HttpError>>,
) {
  return useQuery({
    queryKey: ["breakout-sessions", sessionId],
    queryFn: () => getBreakoutSessions(sessionId),
    ...queryOptions,
  });
}
